type Brands = 'simera' | 'interfell' | 'jobecam';

type BrandConfigurationsType = Record<
  Brands,
  {
    name: string;
    displayName: string;
    logoUrl: string;
    currency: string;
    currencyCode: string;
    locale: string;
    /**
     * FRIENDLY REMINDER
     * Avoid decimals operations at all cost in javascript (for example: 1.2*1.3)
     * This due the IEEE 754 floating point rounding error in Javascript
     * Always convert to integer, make the operation and then switch again to decimal
     */
    convertUsdToCurrency: (amount: number) => number;
    convertCurrencyToUSD: (amount: number) => number;
  }
>;

const CURRENCY_RATES = {
  brl: 5.37,
};

export const BrandConfigurations: BrandConfigurationsType = {
  interfell: {
    name: 'interfell',
    displayName: 'Interfell',
    logoUrl: '/images/brand/interfell-logo.svg',
    currency: '$',
    currencyCode: 'USD',
    locale: 'en-US',
    convertUsdToCurrency: (amount: number) => {
      if (!amount) return 0;
      return amount;
    },
    convertCurrencyToUSD: (amount: number) => amount,
  },
  simera: {
    name: 'simera',
    displayName: 'Simera',
    logoUrl: '/images/brand/simera-dark%20logo.svg',
    currency: '$',
    currencyCode: 'USD',
    locale: 'en-US',
    convertUsdToCurrency: (amount: number) => {
      if (!amount) return 0;
      return amount;
    },
    convertCurrencyToUSD: (amount: number) => amount,
  },
  jobecam: {
    name: 'jobecam',
    displayName: 'Jobecam',
    logoUrl: '/images/brand/jobecam.svg',
    currency: 'R$',
    currencyCode: 'BRL',
    locale: 'pt-BR',
    convertUsdToCurrency: (amount: number) => {
      if (!amount) return 0;
      // Switching decimal to integer and then going back to decimal
      const converted = (amount * 100 * (CURRENCY_RATES.brl * 100)) / 10000;

      const roundedAmount = Math.round(converted / 10) * 10;

      return roundedAmount;
    },
    convertCurrencyToUSD: (amount: number) => {
      const usdAmount = (amount * 100) / (CURRENCY_RATES.brl * 100) / 10000;
      return usdAmount;
    },
  },
};
